module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.invoice) ? _c('div', {
    staticClass: "thankyou-page"
  }, [_c('img', {
    staticClass: "img-responsive ma-auto",
    attrs: {
      "src": require("../../../assets/img/gp-head-hbd@2x.png"),
      "width": "900px",
      "alt": "Celebrate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("เพราะความใจดีของคุณ จึงทำให้น้องๆ มีโอกาสเข้าถึงการศึกษาได้มากขึ้น ")]), _vm._v(" "), _c('div', {
    staticClass: "block-white"
  }, [_vm._m(1), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.showUploadSlipForm) ? _c('div', [_vm._m(3)]) : _vm._e()]), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (!_vm.showUploadSlipForm) ? _c('div', [_vm._m(5)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', {
    staticClass: "show-uploadslip"
  }, [_c('upload-slip')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("ขอบคุณ คุณเฌอปรางค์ อารีย์กุล"), _c('br'), _vm._v("สำหรับการบริจาคและสร้างเพจในโอกาสพิเศษ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-center block-social-share"
  }, [_c('span', [_vm._v("ส่งต่อเพจระดมเงินของคุณให้เพื่อน")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/btn-fb-share.png"),
      "alt": "Facebook Share"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/btn-line-share.png"),
      "alt": "Line Share"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-image-share"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/thankyou-share.png"),
      "alt": "ThankYou Share"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-image-share"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/thankyou-share.png"),
      "alt": "ThankYou Share"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา")]), _c('p'), _vm._v("หากบริจาคด้วยวิธีการโอนเงิน กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้"), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่"), _c('br'), _vm._v("คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea77ae3c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/thank-you/_birthday.vue
// module id = 1222
// module chunks = 0